import { Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchDeliveryToggleService {
  public toggleIsOn = false;
  public toggleIsDisabled = true;

  constructor() {}

  toggleState: Subject<boolean> = new Subject<boolean>();

  async toggle() {
    this.toggleIsOn = !this.toggleIsOn;
    this.toggleState.next(this.toggleIsOn);
  }
}
